/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Autocomplete,
  Checkbox,
  Grid,
  InputLabel,
  Paper,
  TextField,
} from "@mui/material";
import { AlertModel } from "../../Utils/Models";
import { handleChangeAutocomplete, onChangeTextField } from "../../Utils/Utils";
import { Vocabulary } from "../../Utils/Vocabulary";
import { SketchPicker } from "react-color";

type OneAlertProps = {
  alert: AlertModel;
  propertyOptions: string[];
  ruleOptions: { label: string; value: string }[];
  onChange: (alert: AlertModel) => void;
};
export default function OneAlert(props: OneAlertProps) {
  const { alert, propertyOptions, ruleOptions, onChange } = props;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6} lg={6}>
        <TextField
          label={Vocabulary.name}
          name="name"
          size="small"
          fullWidth
          value={alert.name}
          onChange={(e) => {
            onChange(onChangeTextField(e, alert));
          }}
        />
      </Grid>
      <Grid item xs={12} md={4.5} lg={4.5}>
        <Autocomplete
          fullWidth
          value={alert.property}
          onChange={(event, newValue) => {
            onChange(
              handleChangeAutocomplete(event, newValue, alert, "property")
            );
          }}
          options={propertyOptions}
          getOptionLabel={(option) => Vocabulary[option] || option}
          renderInput={(params) => (
            <TextField {...params} label={Vocabulary.property} size="small" />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4.5} lg={4.5}>
        <Autocomplete
          fullWidth
          value={
            ruleOptions.find((element) => element.value === alert.rule) || null
          }
          onChange={(event, newValue) => {
            onChange(
              handleChangeAutocomplete(
                event,
                newValue ? newValue.value : newValue,
                alert,
                "rule"
              )
            );
          }}
          options={ruleOptions}
          getOptionLabel={(option) => option.label}
          renderInput={(params) => (
            <TextField {...params} label={Vocabulary.rule} size="small" />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4} lg={3}>
        <TextField
          fullWidth
          label={Vocabulary.threshold}
          name="threshold"
          size="small"
          value={alert.threshold}
          onChange={(e) => {
            onChange(onChangeTextField(e, alert));
          }}
        />
      </Grid>
      <Grid item xs={12} md={6} lg={6}>
        <InputLabel style={{ margin: "10px 0px" }}>
          {Vocabulary.choseColor}
        </InputLabel>
        <div
          style={{
            display: "flex",
          }}
        >
          <SketchPicker
            color={alert.color}
            onChangeComplete={(color: any) =>
              onChange({ ...alert, color: color.hex })
            }
          />
          <Paper
            style={{
              width: 50,
              height: 50,
              margin: "0px 30px",
              backgroundColor: alert.color,
            }}
          ></Paper>
        </div>
      </Grid>
      <Grid item xs={12} md={6} lg={6}>
        <Checkbox
          style={{ marginTop: 10 }}
          checked={alert.sendEmail}
          onChange={(e) => {
            onChange({ ...alert, sendEmail: e.target.checked });
          }}
        />
        {Vocabulary.sendEmail}
      </Grid>
    </Grid>
  );
}
